<template>
  <div>
    <LoadingIndicator v-if="loading"/>

    <template v-else>
      <div class="status-key">
        <div class="status-key-item">Lista para completar</div>
        <div class="status-key-item -blue">Sin fotos</div>
        <div class="status-key-item -red">Incidencia</div>
      </div>
      <Card
        v-for="card in cards"
        :key="card.id"
        :card-data="card"
        @click-complete="onCardCompleteVisitClick(card.id)"
      />
    </template>
  </div>
</template>

<script>
import LoadingIndicator from '@/components/LoadingIndicator';

import Card from './Card';

export default {
  name: 'MobileView',

  props: {
    cards: {
      type: Array,
    },

    loading: {
      type: Boolean,
    },
  },

  methods: {
    onCardCompleteVisitClick(payload) {
      this.$emit('card-click-complete', payload);
    },
  },

  components: {
    Card,
    LoadingIndicator,
  },
};
</script>

<style lang="scss" scoped>
.status-key {
  margin-bottom: 36px;
  padding-left: 10px;

  .status-key-item {
    font-size: 14px;
    display: flex;
    align-items: center;

    &::before {
      content: '';
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background: #348e42;
      margin-right: 10px;
    }

    &.-red::before {
      background: #f04747;
    }

    &.-blue::before {
      background: #0085ff;
    }

    &:not(:last-of-type) {
      margin-bottom: 8px;
    }
  }
}
</style>
